import axios from './axios';

// POST create substore
export async function createSubstore(data) {
  try {
    const response = await axios.post('/owner/substores/add/', data);
    return response.data;
  } catch (error) {
    throw error;
  }
}
